import { render } from "./BoiteASon.vue?vue&type=template&id=2e647c22&scoped=true"
import script from "./BoiteASon.vue?vue&type=script&lang=js"
export * from "./BoiteASon.vue?vue&type=script&lang=js"

import "./BoiteASon.vue?vue&type=style&index=0&id=2e647c22&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e647c22"]])

export default __exports__